export enum EQuotaAccountingType {
  issuingAnOffer = 'issuing_an_offer',
  acceptingAnOffer = 'accepting_an_offer',
}
